const constants = {
  VALIDATE_START: 'VALIDATE_START',
  VALIDATE_END: 'VALIDATE_END',
  VALIDATE_FAILED: 'VALIDATE_FAILED',
  VALIDATE_INITIAL: 'VALIDATE_INITIAL',
};

export default constants;
